
const getOptionsData = (checksData) => checksData.get('options');
const getMaxOptions = (checksData) => checksData.get('maxOptions');
const isAnswered = (localAnswer) => localAnswer && localAnswer.length > 0;

export {getOptionsData, getMaxOptions, isAnswered}